import React, { ComponentPropsWithoutRef, FC } from 'react';
import cx from 'classnames';

import styles from './styles.module.css';

type GradientsProps = ComponentPropsWithoutRef<'svg'>;

const Gradients: FC<GradientsProps> = ({
  className,
  xmlns = 'http://www.w3.org/2000/svg',
  viewBox = '0 0 100 100',
  ...props
}) => (
  <svg
    className={cx(styles.gradients, className)}
    xmlns={xmlns}
    viewBox={viewBox}
    {...props}
  >
    <defs>
      <linearGradient id="dashabord-gradient-error" x2="0%" y2="100%">
        <stop offset="0%" stopColor="var(--color-error-lightest)" />
        <stop offset="100%" stopColor="var(--color-light)" />
      </linearGradient>
      <linearGradient id="dashabord-gradient-success" x2="0%" y2="100%">
        <stop offset="0%" stopColor="var(--color-success-lightest)" />
        <stop offset="100%" stopColor="var(--color-light)" />
      </linearGradient>
    </defs>
  </svg>
);

export default Gradients;
